export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/transactionHistory.worker.8ca3b258.worker.js");
}
